export const DealBannerConstants = {
    v1: 'ctdnt',
    v2: 'CDTv2',
    minutes: 20,
};

export const leadSourceOptions = [
    {
        name: 'Choose one...',
        value: null,
    },
    {
        name: 'Google',
        value: 'google',
    },
    {
        name: 'Yelp',
        value: 'yelp',
    },
    {
        name: 'Facebook',
        value: 'facebook',
    },
    {
        name: 'Twitter',
        value: 'twitter',
    },
    {
        name: 'Thumbtack',
        value: 'thumbtack',
    },
    {
        name: 'Nextdoor',
        value: 'nextdoor',
    },
    {
        name: 'Email',
        value: 'email',
    },
    {
        name: 'Billboard',
        value: 'billboard',
    },
    {
        name: 'Direct Mail',
        value: 'direct mail pieces',
    },
    {
        name: 'Radio',
        value: 'radio',
    },
    {
        name: 'Press',
        value: 'press',
    },
    {
        name: 'Friend/Family',
        value: 'word of mouth',
    },
    {
        name: 'Yard Sign',
        value: 'yard sign',
    },
    {
        name: 'Other',
        value: 'other',
    },
];

// instant quotes
export const serviceIdToInstantQuote = {
    8: {
        type: 'instant_quote_bush_trimming',
        dummyId: 'dummyBushId',
        endpointSuffix: 'bush-trimmings',
    },
    10: {
        type: 'instant_quote_leaf_removal',
        dummyId: 'dummyLeafId',
        endpointSuffix: 'leaf-removals',
    },
};
